import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { ApiSearchQuery } from '@/lib/api/api-type-helper';
import type { GetPublicIdsListRes } from './-query/type';
type PublicIdsTableRow = GetPublicIdsListRes['items'][number];
type PublicIdsQuery = ApiSearchQuery<'/v2/public-ids', 'get'>;

// Public IDs のカテゴリフィルターキー
export const PublicIdCategoryFilterKey = {
  NATIONAL_ID: 'NATIONAL_ID',
  TRAVEL_DOCUMENT: 'TRAVEL_DOCUMENT',
  ALL: 'ALL'
} as const satisfies Record<NonNullable<PublicIdsQuery['publicIdType']>, string>;
export type PublicIdCategoryFilterKey = EnumUnion<typeof PublicIdCategoryFilterKey>;

// Public IDs テーブルの列定義
export const Columns = {
  NATIONAL_ID_TYPE: 'nationalIdType',
  PERSON: 'person',
  ISSUE_DATE: 'issueDate',
  EXPIRY_DATE: 'expiryDate'
} as const satisfies Record<string, keyof PublicIdsTableRow>;